import { faker } from '@faker-js/faker';

export function createRandomSite() {
  return {
    subjectsCount: faker.number.int({ min: 1, max: 500 }),
    id: faker.string.alphanumeric(10),
    code: `Site ${faker.string.numeric(3)}`,
    principalInvestigator: 'string',
    imagingFacilities: [
      {
        id: faker.string.alphanumeric(10),
        name: `MRN_${faker.string.numeric(6)}`,
      },
    ],
  };
}

export function createRandomSiteList(count: number) {
  return faker.helpers.multiple(createRandomSite, { count });
}
